import Image from 'app/Components/Shared/Image/image';
import ExternalTvContentsBlockData from 'app/Models/Content/ExternalTvContentsBlockData';
import React, {useState, useEffect} from 'react';
import {Swiper, SwiperSlide} from 'swiper/react';
import SwiperCore, {Navigation} from 'swiper';
import 'swiper/swiper.scss';
import PopUp from 'app/Components/Shared/Popup/PopUp';
import ProviderManager from '../../../provider/providerManager';
import {Container} from 'reactstrap';
import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import useFadeIn from 'app/Components/Shared/UseFadeIn';
import {ImageProps} from 'app/utilities/ImageProps';

SwiperCore.use([Navigation]);

type PopupData = {
  summary: string;
  image: ImageProps;
  title: string;
};

const ExternalTvContentsBlock = ({data, context}: ComponentProps<ExternalTvContentsBlockData>) => {
  const {fadeClass, ref} = useFadeIn();

  const [popupData, setPopupData] = useState<PopupData>(null);

  const [listTv, setListTv] = useState(null);
  const [showPopUp, setShowPopUp] = useState(false);

  const openPopup = (event, summary: string, image: ImageProps, title: string) => {
    event.preventDefault();
    setPopupData({
      summary,
      image,
      title,
    });
    setShowPopUp(true);
  };

  useEffect(() => {
    ProviderManager.getProviderData('getTvCatalogItems', [data.categoryId.value, '0', '50', '0'])
      .then((res) => {
        setListTv(res.Body.listTv);
      })
      .catch((error) => {});
  }, []);

  const isBig = data.bigImage.value == true;

  const id = data.categoryId.value;

  const toggleArrows = (swiper: SwiperCore) => {
    setTimeout(() => {
      if (swiper.isBeginning && swiper.isEnd) {
        swiper.navigation?.nextEl?.classList.add('hide');
        swiper.navigation?.prevEl?.classList.add('hide');
      } else {
        swiper.navigation?.nextEl?.classList.remove('hide');
        swiper.navigation?.prevEl?.classList.remove('hide');
      }
    });
  };

  return (
    <>
      <div ref={ref} className={`ExternalTvContentsBlock ${fadeClass}`}>
        <Container>
          {data.categoryName.value.length > 0 && <span className='ExternalTvContentsBlock__categoryTitle'>{data.categoryName.value}</span>}
        </Container>
        <Container fluid>
          {/* mobile */}

          {listTv && listTv.length > 0 && (
            <Swiper
              spaceBetween={isBig ? 9 : 7}
              className='ExternalTvContentsBlock__swiper d-md-none d-lg-none d-xl-none'
              slidesPerView={isBig ? 1.1 : 2.25}>
              {listTv?.map((item, i) => {
                return (
                  <SwiperSlide onClick={(e) => openPopup(e, item.description, {src: item.imageUrl, alt: ''}, item.name)} key={i}>
                    <div className={`ExternalTvContentsBlock__swiper__${isBig ? `big` : `small`}-image-wrap`}>
                      <Image className={`ExternalTvContentsBlock__swiper__${isBig ? `big` : `small`}-image-wrap__${
                          isBig ? `big` : `small`
                        }-image`}
                        src={item.imageUrl}
                        alt='' />
                    </div>
                    <span className='ExternalTvContentsBlock__swiper__title'>{item.name}</span>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          )}

          {/* desktop */}

          {listTv && listTv.length > 0 && (
            <Swiper
              centerInsufficientSlides
              navigation={{
                nextEl: `${isBig ? '.big-external-swiper' : '.small-external-swiper'}-nextEl.${id}`,
                prevEl: `${isBig ? '.big-external-swiper' : '.small-external-swiper'}-prevEl.${id}`,
              }}
              className='ExternalTvContentsBlock__swiper d-none d-md-block d-lg-block d-xl-block'
              spaceBetween={10}
              onInit={toggleArrows}
              onResize={toggleArrows}
              slidesPerView='auto'>
              {listTv?.map((item, i) => {
                return (
                  <SwiperSlide
                    onClick={(e) => {
                      openPopup(e, item.description, {src: item.imageUrl, alt: ''}, item.name);
                    }}
                    key={i}>
                    <div className={`ExternalTvContentsBlock__swiper__${isBig ? `big` : `small`}-image-wrap`}>
                      <Image className={`ExternalTvContentsBlock__swiper__${isBig ? `big` : `small`}-image-wrap__${
                          isBig ? `big` : `small`
                        }-image`}
                        src={item.imageUrl}
                        alt='' />
                    </div>

                    <span className='ExternalTvContentsBlock__swiper__title'>{item.name}</span>
                  </SwiperSlide>
                );
              })}

              <div className={`${isBig ? 'big-external-swiper' : 'small-external-swiper'}-prevEl ${id}`}>
                <svg xmlns='http://www.w3.org/2000/svg' width='16' height='22' viewBox='0 0 16 22'>
                  <g fill='none' fill-rule='evenodd'>
                    <g fill='var(--theme-primary, #810ea9)' fill-rule='nonzero'>
                      <g>
                        <path
                          d='M9.731.769c1.025-1.025 2.687-1.025 3.712 0 .972.971 1.023 2.514.154 3.545l-.154.167L7.425 10.5l6.018 6.019c.972.971 1.023 2.514.154 3.545l-.154.167c-.97.971-2.514 1.022-3.545.153l-.167-.153L0 10.5 9.731.769z'
                          transform='translate(-1386 -947) translate(1386 947) matrix(-1 0 0 1 14.962 .5)'></path>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>

              <div className={`${isBig ? 'big-external-swiper' : 'small-external-swiper'}-nextEl ${id}`}>
                <svg xmlns='http://www.w3.org/2000/svg' width='16' height='22' viewBox='0 0 16 22'>
                  <g fill='none' fill-rule='evenodd'>
                    <g fill='var(--theme-primary, #810ea9)' fill-rule='nonzero'>
                      <g>
                        <path
                          d='M9.731.769c1.025-1.025 2.687-1.025 3.712 0 .972.971 1.023 2.514.154 3.545l-.154.167L7.425 10.5l6.018 6.019c.972.971 1.023 2.514.154 3.545l-.154.167c-.97.971-2.514 1.022-3.545.153l-.167-.153L0 10.5 9.731.769z'
                          transform='translate(-39 -947) translate(39 947) translate(.813 .5)'
                        />
                      </g>
                    </g>
                  </g>
                </svg>{' '}
              </div>
            </Swiper>
          )}
        </Container>
      </div>

      <PopUp className={'ExternalTvContentsBlock__container-popup'} showPopUp={showPopUp} onClose={() => setShowPopUp(false)}>
        <Image className='ExternalTvContentsBlock__container-popup__popup-image' {...popupData?.image} />

        <div className='ExternaltTvContentsBlock__container-popup__popup-title-and-text'>
          <h4>{popupData?.title}</h4>

          <div dangerouslySetInnerHTML={{__html: popupData?.summary}}></div>
        </div>
      </PopUp>
    </>
  );
};

export default ExternalTvContentsBlock;
